import React from "react";
import {UncontrolledDropdown, DropdownItem, DropdownToggle, DropdownMenu} from "reactstrap";

import {Link, NavLink, useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import menu from "../redux/menu";

import Icon from "./Icon";

const TopNav = () => {
	const dispatch = useDispatch();
	const user = useSelector(({authentication: {user}}) => user);
	const location = useLocation();

	const toggleMenu = React.useCallback(() => {
		dispatch(menu.actions.toggle());
	}, []);

	const navbarRight = React.useMemo(() => {
		return (
			<UncontrolledDropdown className="user dropdown-menu-right h-100">
				<DropdownToggle className="p-0" color="empty">
					<span className="name">{user.email}</span>
				</DropdownToggle>
				<DropdownMenu right>
					<DropdownItem tag={Link} to={'/admin/logout'}>Logout</DropdownItem>
				</DropdownMenu>
			</UncontrolledDropdown>
		);
	}, [user, location]);

	const logo = React.useMemo(() => {
		return (
			<>
				<div className="d-block h-100 py-2">
					<img src="/images/horus.png" className="h-100"/>
				</div>
			</>
		);
	}, [user]);

	return (
		<nav className="navbar fixed-top d-flex justify-content-between">
			<div className="text-center h-100 py-2" style={{marginLeft: 30}}>
				<Link className="d-block h-100" to={'/'}>
					{logo}
				</Link>
			</div>
			<div className="flex-fill"/>
			<div className="navbar-right">
				{navbarRight}
			</div>
		</nav>
	);
};

export default TopNav;
